import { dataFetcher } from 'core/services/requestHandler';   

export const getActivityLog = async (data = {}, config = {}) => {
  return dataFetcher('/activity/getByUserType', data, {...config});
};
